import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'Llevaba 3 años con dolor lumbar constante. A las 3 semanas empecé a dormir sin despertarme por el dolor. Hoy camino diferente.',
  name: 'Valeria R.',
  details: '38 años, Córdoba — escoliosis lumbar'
}, {
  quote: 'Me diagnosticaron hipercifosis a los 16 y nadie me explicó qué hacer. Con este material entendí todo y en 6 semanas mi postura cambió visiblemente.',
  name: 'Tomás G.',
  details: '17 años, Rosario — hipercifosis'
}, {
  quote: 'Trabajo 8 horas sentada y la lordosis me tenía con contracturas. Empecé con 15 min por día y en un mes dejé el ibuprofeno.',
  name: 'Luciana M.',
  details: '43 años, CABA — hiperlordosis'
}];
export function Testimonials() {
  return <section className="py-10 md:py-20 bg-slate-50" data-id="element-335">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <div className="text-center mb-8 md:mb-12" data-id="element-337">
          <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-338">
            Lo que dicen quienes ya lo tienen
          </h2>
          <div className="w-16 h-1 bg-brand-accent mx-auto rounded-full" data-id="element-339"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5" data-id="element-340">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white p-5 rounded-xl shadow-sm border border-slate-100 flex flex-col h-full" data-id="element-341">
              <div className="flex text-yellow-400 mb-3" data-id="element-342">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-343" />)}
              </div>
              <p className="text-slate-700 text-sm md:text-[15px] mb-4 flex-grow leading-relaxed" data-id="element-344">
                "{testimonial.quote}"
              </p>
              <div className="pt-3 border-t border-slate-100" data-id="element-345">
                <p className="font-bold text-slate-900 text-sm" data-id="element-346">
                  {testimonial.name}
                </p>
                <p className="text-xs text-slate-500 mt-0.5" data-id="element-347">
                  {testimonial.details}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}